import React from 'react'
import { Row, Col, Button, Divider } from 'antd'
import { ArrowRightOutlined, ArrowLeftOutlined } from '@ant-design/icons'
import { useAppDispatch } from 'src/app/hooks'
import { setUserRegisterButtonStepValue } from 'src/features'
import { useTranslation } from 'next-i18next'

interface PropsType {
  nextStepValue: number,
  beforeStepValue?: number,
  loading?: boolean
}

const StepChanger = ({ nextStepValue, beforeStepValue = null, loading = false }: PropsType) => {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()

  const isSubmitStep = () => {
    return nextStepValue === 1 && beforeStepValue === 0
  }

  return (
    <>
      <Divider />
      <Row>
        {beforeStepValue !== null ? (
          <Col xs={24} lg={12}>
            <Button
              type='default'
              className='radius-100'
              icon={<ArrowLeftOutlined />}
              size={'large'}
              onClick={() => dispatch(setUserRegisterButtonStepValue(beforeStepValue))}
            >
              {t('card.Back')}
            </Button>
          </Col>
        ) : (
          <Col xs={24} lg={12} />
        )}
        <Col xs={24} lg={12}>
          <Button
            type='primary'
            htmlType='submit'
            className='float-right radius-100'
            loading={loading}
            icon={<ArrowRightOutlined />}
            size={'large'}
          >
            {isSubmitStep() ? (
              <>
                {loading ? t('admin.Brokerage.CreatingUser') : t('admin.Brokerage.CreateUser')}
              </>
            ) : t('card.Continue')}
          </Button>
        </Col>
      </Row>
    </>
  )
}
export default StepChanger
